var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('span',{staticClass:"position"},[(_vm.display != 'devmode')?_c('NavBar'):_vm._e()],1),_c('router-view'),(_vm.display != 'devmode')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }